export default {
  getOverlay: state => state.overlay,
  getLoader: state => state.loader,
  getLoaderText: state => state.loaderText,
  getMessages: state => state.messages
}
